import { RichTextFormatter, translateFormatter } from '@/core/localization/translate';
export const billieBannerDescription = translateFormatter<{
  bold: RichTextFormatter;
}>("Paiement jusqu\u2019\xE0 <bold>30 jours,</bold> sans frais", undefined, undefined, "en");